import dayjs from 'dayjs';
import { type TFunction } from 'i18next';
import type * as React from 'react';
import {
  type SearchableFieldRange,
  SearchableFieldType,
} from '../../ISearchableField.tsx';

type RangeBound = string | number | null | undefined;

/** Formatter per `DateRange` / `NumberRange`: gestisce i 4 stati from/to. */

export function formatRangeFilterBarValue(
  field: SearchableFieldRange,
  from: RangeBound,
  to: RangeBound,
  t: TFunction,
): React.ReactNode {
  if (field.type === SearchableFieldType.DateRange) {
    const fmt = (v: RangeBound) =>
      v != null && v !== '' ? dayjs(v).format('DD/MM/YYYY') : null;
    const fromStr = fmt(from);
    const toStr = fmt(to);
    if (fromStr && toStr) return `${fromStr} → ${toStr}`;
    if (fromStr)
      return t('filter-bar.range-from', 'Dal {{value}}', {
        value: fromStr,
      });
    if (toStr)
      return t('filter-bar.range-to', 'Al {{value}}', {
        value: toStr,
      });
    return null;
  }
  // NumberRange
  if (from != null && to != null) return `${from} – ${to}`;
  if (from != null)
    return t('filter-bar.range-from-num', 'Da {{value}}', {
      value: String(from),
    });
  if (to != null)
    return t('filter-bar.range-to-num', 'A {{value}}', {
      value: String(to),
    });
  return null;
}
